<template>
  <div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title mb-4">اپلیکیشن های نمایش دهنده کمپین</h4>
        <div id="income-type-chart" class="apex-charts"></div>
        <apexchart
          v-if="series.length > 0"
          class="apex-charts"
          height="230"
          dir="rtl"
          :series="series"
          :options="{
            ...chartOptions,
            ...{
              labels: labels.map((item) => item.name),
              tooltip: {
                y: {
                  formatter: function(value) {
                    let Number = value;
                    Number += '';
                    Number = Number.replace(',', '');
                    const x = Number.split('.');
                    let y = x[0];
                    const z = x.length > 1 ? '.' + x[1] : '';
                    const rgx = /(\d+)(\d{3})/;
                    while (rgx.test(y)) y = y.replace(rgx, '$1' + ',' + '$2');
                    return y + z + ' نمایش';
                  },
                },
              },
            },
          }"
        ></apexchart>
        <div
          v-if="series.length > 0"
          class="row flex justify-content-center align-items-center flex-wrap"
        >
          <div class="mx-2" :key="i" v-for="(item, i) in series">
            <div class="text-center mt-4">
              <a
                :href="`https://cafebazaar.ir/app/${labels[i].pkgNameAndroid}`"
                class="mb-2"
              >
                <i
                  class="mdi mdi-circle font-size-10 mr-1"
                  :style="{ color: chartOptions.colors[i] }"
                ></i>
                {{ labels[i].name }}
              </a>
              <h5>
                {{
                  item !== 0
                    ? (
                        (item * 100) /
                        $helper.calculateChartSeriesTotal(series)
                      ).toFixed(0)
                    : 0
                }}%
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pieChartOptions from "@/data/pie-chart-options.js";

export default {
  props: {
    campaignId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      chartOptions: pieChartOptions,
      series: [],
      labels: [],
    };
  },
  mounted() {
    this.fetchChartData();
  },
  methods: {
    fetchChartData() {
      this.$axios
        .get(`campaigns/${this.campaignId}/logs/chart/group-by-application`)
        .then((res) => {
          this.labels = res.data.map((item) => item.application);
          this.series = res.data.map((item) => item.count);
        });
    },
  },
};
</script>

<style></style>
